import Hashids from "hashids"

// Standalone scenario id hashing. Kept free of any app/ React/Blitz imports so it can be
// imported from contexts that can't load the heavy chain (e.g. Playwright e2e tests),
// instead of duplicating the salt. Re-exported from formatting_utils for back-compat.
const HASH_LENGTH = 8
const hashids = new Hashids("TESA hashing salt", HASH_LENGTH)

export function scenarioIdEncode(id: number): string {
  return hashids.encode(id)
}

export function scenarioIdDecode(hash: string | undefined) {
  if (!hash) return
  return hashids.decode(hash)[0] as number
}
